import Carousel from 'react-bootstrap/Carousel';
// import Timer from '../../components/Timer';
import banner2026_1 from '../../images/banner2026_1.png';
import banner2026_2 from '../../images/banner2026_2.png';
import banner2026_3 from '../../images/banner2026_3.png';
import banner2026_4 from '../../images/banner2026_4.png';

import SupportersLogo from '../../components2026/SupportersLogo.jsx';


// import SponsorsImg from '../components/SponsorsImg';
import { Link, useNavigate, useLocation } from "react-router-dom";

import { VerticalTimeline, VerticalTimelineElement } from 'react-vertical-timeline-component';
import 'react-vertical-timeline-component/style.min.css';
import Themes from '../../components2026/Themes.jsx';
import "../../stylesheets2025/registration.css";
import "../../stylesheets2025/home.css";
import brochureSanket from "../../pdf2026/sanket2026.pdf"
import proposalSanket from "../../pdf2026/sanket2026-SPONSORSHIP.pdf"
import Speakers from './Speakers.jsx';
import EventDetails from './EventDetails.jsx';
import Venue from './Venue.jsx';
import Awards from "./Awards.jsx"
import Supporters from './Supporters.jsx';
import CustomCarousel from '../../components2026/CustomCarousel.jsx';
import image1 from "../../images/conference/previous_conference_1.jpeg";
import image2 from "../../images/conference/previous_conference_2.jpeg";
import image3 from "../../images/conference/previous_conference_3.jpeg";
import image4 from "../../images/conference/previous_conference_4.jpeg";
import image5 from "../../images/conference/previous_conference_5.jpeg";
import image6 from "../../images/conference/previous_conference_6.jpeg";
import image7 from "../../images/conference/previous_conference_7.jpeg";


function getMonthName(monthNumber) {
  const date = new Date(2000, monthNumber - 1, 1); // Any year, month-1, day 1
  return new Intl.DateTimeFormat('en-US', { month: 'long' }).format(date);
}

function ordinalDay(n) {
  const j = n % 10;
  const k = n % 100;
  if (j === 1 && k !== 11) return `${n}st`;
  if (j === 2 && k !== 12) return `${n}nd`;
  if (j === 3 && k !== 13) return `${n}rd`;
  return `${n}th`;
}

const CONFERENCE_YEARS = ["2026", "2025", "2024"];

const Home = ({ day, endDay, month, year, startTime, endTime, weekDay, venue }) => {
  const navigate = useNavigate();
  const location = useLocation();
  const routeYearMatch = location.pathname.match(/^\/(\d{4})(\/|$)/);
  const routeYear = routeYearMatch?.[1];
  const selectYear =
    routeYear && CONFERENCE_YEARS.includes(routeYear) ? routeYear : "2026";


  const monthName = getMonthName(month);
  const eventDate = new Date(`${year}-${month}-${day}T00:00:00Z`);

  const products = [
    { image: image1 },
    { image: image2 },
    { image: image3 },
    { image: image4 },
    { image: image5 },
    { image: image6 },
    { image: image7 },
  ];

  return (
    <>



      <div className="carouselplay">
        <Carousel>
          <Carousel.Item interval={4000}>
            <img src={banner2026_1} alt="SANKET - Sustainability through Ancient Knowledge and Emerging Technologies" />
          </Carousel.Item>
          <Carousel.Item interval={4000}>
            <img src={banner2026_2} alt="SANKET conference - Energy and Sustainability" />
          </Carousel.Item>
          <Carousel.Item interval={4000}>
            <img src={banner2026_3} alt="Environmental Conservation Initiative" />
          </Carousel.Item>
          <Carousel.Item interval={4000}>
            <img src={banner2026_4} alt="SANKET 2026 conference presentation" />
          </Carousel.Item>
        </Carousel>

        {/*<div class="carousel slide"><div class="carousel-indicators"><button type="button" data-bs-target="" aria-label="Slide 1" aria-current="true" class="active"></button><button type="button" data-bs-target="" aria-label="Slide 2" aria-current="false"></button><button type="button" data-bs-target="" aria-label="Slide 3" aria-current="false"></button></div><div class="carousel-inner"><div interval="5000" class="active carousel-item"><img src="/pera-react-final/static/media/slide1.762c2c3e5c60cf51cff3.jpg" alt=""></div><div interval="5000" class="carousel-item"><img src="/pera-react-final/static/media/slide2.2faacea92ce0fa7b247c.jpg" alt=""></div><div interval="5000" class="carousel-item"><img src="/pera-react-final/static/media/slide3.9daa59e750abcd0a69f5.jpg" alt=""></div></div><a class="carousel-control-prev" role="button" tabindex="0" href="#" style="
    background: black;
    opacity: 1;
"><span aria-hidden="true" class="carousel-control-prev-icon"></span><span class="visually-hidden">Previous</span></a><a class="carousel-control-next" role="button" tabindex="0" href="#"><span aria-hidden="true" class="carousel-control-next-icon"></span><span class="visually-hidden">Next</span></a></div> */}
        <div className="cap ">

          <h1 className='text-lg lg:text-4xl'>
            SANKET  <br /> Sustainability through Ancient Knowledge and Emerging Technologies <br />{' '}
            <span className='text-sm lg:text-xl'>
              {endDay != null
                ? `${ordinalDay(day)} and ${ordinalDay(endDay)} of ${monthName}, ${year}, ${venue}`
                : `${ordinalDay(day)} ${monthName}, ${weekDay}, ${startTime} - ${endTime}, ${venue}`}
            </span>
          </h1>
        </div>
      </div>


      <VerticalTimeline layout='1-column-right'>


        <VerticalTimelineElement
          className="vertical-timeline-element--work  "
          date={`Venue: ${venue}`}
          iconStyle={{ color: '#fff' }}


        >
          <h3 className="vertical-timeline-element-title">Event Date</h3>

          <p>
            {endDay != null
              ? `${ordinalDay(day)} and ${ordinalDay(endDay)} of ${monthName}, ${year}`
              : `${ordinalDay(day)} ${monthName}, ${year}`}
          </p>

        </VerticalTimelineElement>
        <VerticalTimelineElement
          className="vertical-timeline-element--work  "

          iconStyle={{ color: '#fff' }}


        >
          <h3 className="vertical-timeline-element-title">Registration Begins</h3>

          <p>
            1<sup>st</sup> October, 2026
          </p>

        </VerticalTimelineElement>

        <VerticalTimelineElement
          className="vertical-timeline-element--work  "

          iconStyle={{ color: '#fff' }}


        >
          <h3 className="vertical-timeline-element-title">Early Bird Registration</h3>

          <p>
            7<sup>th</sup> November, 2026
          </p>

        </VerticalTimelineElement>

        <VerticalTimelineElement
          className="vertical-timeline-element--work  "
          iconStyle={{ color: '#fff' }}
        >
          <h3 className="vertical-timeline-element-title">Final Registration Deadline</h3>

          <p>
            10<sup>th</sup> November, 2026
          </p>

        </VerticalTimelineElement>

        <VerticalTimelineElement
          className="vertical-timeline-element--work  "
          iconStyle={{ color: '#fff' }}
        >
          <h3 className="vertical-timeline-element-title">Camera-Ready Paper Submission</h3>

          <p>
            10<sup>th</sup> November, 2026
          </p>

        </VerticalTimelineElement>


      </VerticalTimeline>

      {/* PERA Sponsors */}


      <div style={{ textAlign: "center" }}>
        <h2>Previous conference images</h2>
        <CustomCarousel items={products} autoSlide={true} autoSlideInterval={3000} />
      </div>





      <div className="about-pera">
        <span className="heading lgreen">
          <h1>Core Themes</h1></span>

        {/* <ThemesList/> */}
        <Themes />


      </div>

      {/* spakers and pannel list */}
      {/* <div className='pt-5'>
        <Speakers />
      </div> */}
      {/* Event details page */}



      {/* <EventDetails /> */}



      {/* <Awards /> */}

      <Supporters />

      <div
        className="conference-select-wrap"
        style={{ textAlign: "center", marginBottom: "30px" }}
      >
        <label htmlFor="conference-year-select" className="sr-only">
          Current and previous conferences — choose a year
        </label>
        <select
          id="conference-year-select"
          className="conference-year-select"
          value={selectYear}
          aria-label="Switch conference year — current (2026) or previous (2025, 2024)"
          onChange={(e) => {
            const year = e.target.value;
            if (CONFERENCE_YEARS.includes(year)) {
              navigate(`/${year}`);
              setTimeout(() => {
                window.scrollTo(0, 0);
              }, 0);
            }
          }}
        >
          <option value="2026">2026 — Current conference</option>
          <option value="2025">2025 — Previous conference</option>
          <option value="2024">2024 — Previous conference</option>
        </select>
      </div>


      <div className="brochure-section">
        <h2 className="brochure-title">Event Brochures</h2>

        <div className="brochure-container">
          <a
            href={brochureSanket}
            download="brochure-sanket.pdf"
            className="download-btn"
          >
            Download Brochure (PDF)
          </a>

          <a
            href={proposalSanket}
            download="Sponsorship-proposal-sanket.pdf"
            className="download-btn alt"
          >
            Download Sponsorship Proposal (PDF)
          </a>
        </div>
      </div>

      <Venue />



      {/* <div className="countdown">
        <Timer eventDate={eventDate} />
      </div> */}


    </>
  )
}

export default Home;


// import Carousel from 'react-bootstrap/Carousel';
// // import Timer from '../../components/Timer';
// import banner2026_1 from '../../images/banner2026_1.png';
// import banner2026_2 from '../../images/banner2026_2.png';
// import banner2026_3 from '../../images/banner2026_3.png';
// import banner2026_4 from '../../images/banner2026_4.png';

// import SupportersLogo from '../../components2026/SupportersLogo.jsx';


// // import SponsorsImg from '../components/SponsorsImg';
// import { Link, useNavigate, useLocation } from "react-router-dom";

// import { VerticalTimeline, VerticalTimelineElement } from 'react-vertical-timeline-component';
// import 'react-vertical-timeline-component/style.min.css';
// import Themes from '../../components2026/Themes.jsx';
// import "../../stylesheets2025/registration.css";
// import "../../stylesheets2025/home.css";
// import brochureSanket from "../../pdf2026/sanket2026.pdf"
// import proposalSanket from "../../pdf2026/sanket2026-SPONSORSHIP.pdf"
// import Speakers from './Speakers.jsx';
// import EventDetails from './EventDetails.jsx';
// import Venue from './Venue.jsx';
// import Awards from "./Awards.jsx"
// import Supporters from './Supporters.jsx';
// import CustomCarousel from '../../components2026/CustomCarousel.jsx';
// import image1 from "../../images/conference/previous_conference_1.jpeg";
// import image2 from "../../images/conference/previous_conference_2.jpeg";
// import image3 from "../../images/conference/previous_conference_3.jpeg";
// import image4 from "../../images/conference/previous_conference_4.jpeg";
// import image5 from "../../images/conference/previous_conference_5.jpeg";
// import image6 from "../../images/conference/previous_conference_6.jpeg";
// import image7 from "../../images/conference/previous_conference_7.jpeg";


// function getMonthName(monthNumber) {
//   const date = new Date(2000, monthNumber - 1, 1); // Any year, month-1, day 1
//   return new Intl.DateTimeFormat('en-US', { month: 'long' }).format(date);
// }

// function ordinalDay(n) {
//   const j = n % 10;
//   const k = n % 100;
//   if (j === 1 && k !== 11) return `${n}st`;
//   if (j === 2 && k !== 12) return `${n}nd`;
//   if (j === 3 && k !== 13) return `${n}rd`;
//   return `${n}th`;
// }

// const CONFERENCE_YEARS = ["2026", "2025", "2024"];

// const Home = ({ day, endDay, month, year, startTime, endTime, weekDay, venue }) => {
//   const navigate = useNavigate();
//   const location = useLocation();
//   const routeYearMatch = location.pathname.match(/^\/(\d{4})(\/|$)/);
//   const routeYear = routeYearMatch?.[1];
//   const selectYear =
//     routeYear && CONFERENCE_YEARS.includes(routeYear) ? routeYear : "2026";


//   const monthName = getMonthName(month);
//   const eventDate = new Date(`${year}-${month}-${day}T00:00:00Z`);

//   const products = [
//     { image: image1 },
//     { image: image2 },
//     { image: image3 },
//     { image: image4 },
//     { image: image5 },
//     { image: image6 },
//     { image: image7 },
//   ];

//   return (
//     <>



//       <div className="carouselplay">
//         <Carousel>
//           <Carousel.Item interval={4000}>
//             <img src={banner2026_1} alt="SANKET - Sustainability through Ancient Knowledge and Emerging Technologies" />
//           </Carousel.Item>
//           <Carousel.Item interval={4000}>
//             <img src={banner2026_2} alt="SANKET conference - Energy and Sustainability" />
//           </Carousel.Item>
//           <Carousel.Item interval={4000}>
//             <img src={banner2026_3} alt="Environmental Conservation Initiative" />
//           </Carousel.Item>
//           <Carousel.Item interval={4000}>
//             <img src={banner2026_4} alt="SANKET 2026 conference presentation" />
//           </Carousel.Item>
//         </Carousel>

//         {/*<div class="carousel slide"><div class="carousel-indicators"><button type="button" data-bs-target="" aria-label="Slide 1" aria-current="true" class="active"></button><button type="button" data-bs-target="" aria-label="Slide 2" aria-current="false"></button><button type="button" data-bs-target="" aria-label="Slide 3" aria-current="false"></button></div><div class="carousel-inner"><div interval="5000" class="active carousel-item"><img src="/pera-react-final/static/media/slide1.762c2c3e5c60cf51cff3.jpg" alt=""></div><div interval="5000" class="carousel-item"><img src="/pera-react-final/static/media/slide2.2faacea92ce0fa7b247c.jpg" alt=""></div><div interval="5000" class="carousel-item"><img src="/pera-react-final/static/media/slide3.9daa59e750abcd0a69f5.jpg" alt=""></div></div><a class="carousel-control-prev" role="button" tabindex="0" href="#" style="
//     background: black;
//     opacity: 1;
// "><span aria-hidden="true" class="carousel-control-prev-icon"></span><span class="visually-hidden">Previous</span></a><a class="carousel-control-next" role="button" tabindex="0" href="#"><span aria-hidden="true" class="carousel-control-next-icon"></span><span class="visually-hidden">Next</span></a></div> */}
//         <div className="cap ">

//           <h1 className='text-lg lg:text-4xl'>
//             SANKET  <br /> Sustainability through Ancient Knowledge and Emerging Technologies <br />{' '}
//             <span className='text-sm lg:text-xl'>
//               {endDay != null
//                 ? `${ordinalDay(day)} and ${ordinalDay(endDay)} of ${monthName}, ${year}, ${venue}`
//                 : `${ordinalDay(day)} ${monthName}, ${weekDay}, ${startTime} - ${endTime}, ${venue}`}
//             </span>
//           </h1>
//         </div>
//       </div>


//       <VerticalTimeline layout='1-column-right'>


//         <VerticalTimelineElement
//           className="vertical-timeline-element--work  "
//           date={`Venue: ${venue}`}
//           iconStyle={{ color: '#fff' }}


//         >
//           <h3 className="vertical-timeline-element-title">Event Date</h3>

//           <p>
//             {endDay != null
//               ? `${ordinalDay(day)} and ${ordinalDay(endDay)} of ${monthName}, ${year}`
//               : `${ordinalDay(day)} ${monthName}, ${year}`}
//           </p>

//         </VerticalTimelineElement>
//         <VerticalTimelineElement
//           className="vertical-timeline-element--work  "

//           iconStyle={{ color: '#fff' }}


//         >
//           <h3 className="vertical-timeline-element-title">Registration Begins</h3>

//           <p>
//             1<sup>st</sup> October, 2026
//           </p>

//         </VerticalTimelineElement>

//         <VerticalTimelineElement
//           className="vertical-timeline-element--work  "

//           iconStyle={{ color: '#fff' }}


//         >
//           <h3 className="vertical-timeline-element-title">Registration Closes</h3>

//           <p>
//             30<sup>th</sup> November, 2026
//           </p>

//         </VerticalTimelineElement>


//       </VerticalTimeline>

//       {/* PERA Sponsors */}


//       <div style={{ textAlign: "center" }}>
//         <h2>Previous conference images</h2>
//         <CustomCarousel items={products} autoSlide={true} autoSlideInterval={3000} />
//       </div>





//       <div className="about-pera">
//         <span className="heading lgreen">
//           <h1>Core Themes</h1></span>

//         {/* <ThemesList/> */}
//         <Themes />


//       </div>

//       {/* spakers and pannel list */}
//       {/* <div className='pt-5'>
//         <Speakers />
//       </div> */}
//       {/* Event details page */}



//       {/* <EventDetails /> */}



//       {/* <Awards /> */}

//       <Supporters />

//       <div
//         className="conference-select-wrap"
//         style={{ textAlign: "center", marginBottom: "30px" }}
//       >
//         <label htmlFor="conference-year-select" className="sr-only">
//           Current and previous conferences — choose a year
//         </label>
//         <select
//           id="conference-year-select"
//           className="conference-year-select"
//           value={selectYear}
//           aria-label="Switch conference year — current (2026) or previous (2025, 2024)"
//           onChange={(e) => {
//             const year = e.target.value;
//             if (CONFERENCE_YEARS.includes(year)) {
//               navigate(`/${year}`);
//               setTimeout(() => {
//                 window.scrollTo(0, 0);
//               }, 0);
//             }
//           }}
//         >
//           <option value="2026">2026 — Current conference</option>
//           <option value="2025">2025 — Previous conference</option>
//           <option value="2024">2024 — Previous conference</option>
//         </select>
//       </div>


//       <div className="brochure-section">
//         <h2 className="brochure-title">Event Brochures</h2>

//         <div className="brochure-container">
//           <a
//             href={brochureSanket}
//             download="brochure-sanket.pdf"
//             className="download-btn"
//           >
//             Download Brochure (PDF)
//           </a>

//           <a
//             href={proposalSanket}
//             download="Sponsorship-proposal-sanket.pdf"
//             className="download-btn alt"
//           >
//             Download Sponsorship Proposal (PDF)
//           </a>
//         </div>
//       </div>

//       <Venue />



//       {/* <div className="countdown">
//         <Timer eventDate={eventDate} />
//       </div> */}


//     </>
//   )
// }

// export default Home;
